var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { actionClass } from "@ane/legacy/lib/decorators/ReduxDecorators";
import { cache } from "@ane/core/lib/services/PromiseCache";
import mdsDataplaneResource from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import { getExperimentationGroupIdFromPath, isManagementGroupNameValid } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ConfigEditorActions = class {
  getConfig(workspaceId, section, path, experimentationGroup, snapshot) {
    return __async(this, null, function* () {
      if (!experimentationGroup) {
        experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, path);
      }
      var json;
      if (section == MasterDataConstants.experimentManagementGroup) {
        json = yield mdsDataplaneResource.getExperimentationGroupById(workspaceId, experimentationGroup);
      } else {
        json = yield mdsDataplaneResource.getConfig({
          workspaceId,
          experimentationGroup,
          section,
          snapshot
        });
      }
      return {
        json,
        section,
        path
      };
    });
  }
  editConfig(workspaceId, section, path, experimentationGroup, snapshot) {
    return __async(this, null, function* () {
      if (!experimentationGroup) {
        experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, path);
      }
      var json;
      if (section == MasterDataConstants.experimentManagementGroup) {
        json = yield mdsDataplaneResource.getExperimentationGroupById(workspaceId, experimentationGroup);
      } else {
        json = yield mdsDataplaneResource.getConfig({
          workspaceId,
          experimentationGroup,
          section,
          snapshot
        });
      }
      return {
        json,
        section,
        path
      };
    });
  }
  clearConfig() {
    return true;
  }
  getSchema(section) {
    return __async(this, null, function* () {
      const json = yield mdsDataplaneResource.getSchema(section);
      return JSON.stringify(json, null, 4);
    });
  }
  getDiffConfig(workspaceId, section, diffPath, snapshot) {
    return __async(this, null, function* () {
      const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, diffPath);
      const json = yield mdsDataplaneResource.getConfig({
        workspaceId,
        experimentationGroup,
        section,
        snapshot
      });
      const config = JSON.stringify(json, null, 4);
      return config;
    });
  }
  changeCode(code) {
    return code;
  }
  changeMode(mode) {
    return mode;
  }
  setExperimentationGroup(workspaceId, path, payload) {
    return __async(this, null, function* () {
      if (!isManagementGroupNameValid(payload.Name)) {
        const error = new Error(
          "Experimentation Group Name is invalid. It can only contain lowercase letters and numbers and must be 3-24 characters long."
        );
        error.isUserError = true;
        throw error;
      }
      const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, path);
      const request = {
        workspaceId,
        experimentationGroup,
        config: JSON.stringify(payload)
      };
      yield mdsDataplaneResource.setExperimentationGroup(request);
    });
  }
  previewConfig(workspaceId, section, experimentationGroup, payload) {
    return __async(this, null, function* () {
      return yield mdsDataplaneResource.previewConfig(workspaceId, section, experimentationGroup, payload);
    });
  }
  getPreviewContent(workspaceId, section, experimentationGroup, payload, targetPath, mergemode) {
    return __async(this, null, function* () {
      const expGrpForTargetPath = getExperimentationGroupIdFromPath(workspaceId, targetPath);
      const jsonPromise = yield mdsDataplaneResource.getConfig({
        workspaceId,
        experimentationGroup: expGrpForTargetPath,
        section
      });
      const previewContentPromise = mdsDataplaneResource.getPreviewContent(
        workspaceId,
        section,
        experimentationGroup,
        payload,
        targetPath,
        mergemode
      );
      yield Promise.all([jsonPromise, previewContentPromise]);
      return {
        section,
        content: yield previewContentPromise,
        targetPath,
        originalContent: yield jsonPromise
      };
    });
  }
  clearPreviewContent() {
    return true;
  }
};
__decorateClass([
  cache()
], ConfigEditorActions.prototype, "editConfig", 1);
ConfigEditorActions = __decorateClass([
  actionClass("admin_app_module")
], ConfigEditorActions);
const configEditorActions = new ConfigEditorActions();
export {
  ConfigEditorActions,
  configEditorActions as default
};
//# sourceMappingURL=ConfigEditorActions.js.map
